import { filterParamTypes } from '../../types/filter';

export const updateFilter = (params: filterParamTypes) => {
  return {
    type: 'SET_FILTER_PROPS',
    filterData: params
  };
};